'use client';

import {
  CachedVirtualizer,
  createCachedVirtualizerStore,
} from '@wwe-portal/web/providers/stores/cached-virtualizer';
import { STORAGE_ITEM_STORE_CACHED_VIRTUALIZER } from '@wwe-portal/web/utils/constants/keys';

import { StoreApi } from 'zustand';

let _store: StoreApi<CachedVirtualizer> | undefined;

export const getCachedVirtualizer = () => {
  if (typeof window === 'undefined') {
    throw new Error('getCachedVirtualizer must be used in client');
  }

  _store ??= createCachedVirtualizerStore(
    { enabledInitialOffset: false },
    STORAGE_ITEM_STORE_CACHED_VIRTUALIZER
  );
  return _store;
};
